import { put, takeLatest, select, call } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import cartAPI from '../../api/cart';
import { Creators as AppCreators } from '../../reducers/app';
import { Types, Creators } from '../../reducers/cart';
import { Creators as CheckoutCreators } from '../../reducers/checkout';
import { getCartId } from '../../utils/cookies';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* cartCouponRequest({ coupon }) {
  try {
    const token = yield select(getToken);
    const { cart, customer, app } = yield select(getState);
    const cartId = cart.id || customer.cartId || getCartId();
    const siteId = app.getIn(['config', 'siteId']);

    const data = yield call(cartAPI.setCoupon, cartId, coupon, token, siteId);

    yield put(CheckoutCreators.getPaymentTypesRequest());
    yield put(CheckoutCreators.removePaymentRequest());
    yield put(AppCreators.feedbackRequest({ message: 'Cupom aplicado', type: 'success', open: true }));
    yield put(Creators.cartCouponSuccess(data));
  } catch (error) {
    yield put(Creators.cartCouponFailed(formatError(error)));
    yield put(AppCreators.feedbackRequest({ message: formatError(error).message, open: true }));
  }
}

export default function* watch() {
  yield takeLatest(Types.CART_COUPON_REQUEST, cartCouponRequest);
}
